var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    'animate-spin rounded-full box-border border-2 border-solid',
    {
      'border-light-text-400 border-t-canary-500': _vm.darkMode === true,
      'border-dark-text-400 border-t-grape-500': _vm.darkMode === false,
      'border-dark-text-400 dark:border-light-text-400 border-t-grape-500 dark:border-t-canary-500':
        _vm.darkMode === 'auto',
    },
  ],style:(_vm.spinnerStyles)})
}
var staticRenderFns = []

export { render, staticRenderFns }